import { Box, Button, Heading, Image, Link, Text } from '@chakra-ui/react';
import { Link as ReachLink } from 'react-router-dom';
import CopyProfileButton from '../../components/CopyProfileButton';
import { ReactComponent as RightArrow } from '../../resources/arrow-up-right.svg';
import './Dashboard.css';

interface Props {
    slug?: string;
}

export default function ProfileLive(props: Props) {
    const { slug } = props;

    const copy = {
        pathmatchProfileLive: {
            header: slug
                ? 'Check out your PathMatch profile 🎉'
                : 'Create your PathMatch Profile 🎉',
            body: slug
                ? 'Apply for roles with your PathMatch profile'
                : 'Once you create your PathMatch profile, you can apply for roles using it!'
        }
    };

    return (
        <Box className="boxContent">
            <Image borderRadius="xl" w="100%" src="/profile-live-illustration.png" />
            <Heading className="boxHeading" mt="6" fontSize={{ base: '24px', lg: '28px' }}>
                {copy.pathmatchProfileLive.header}
            </Heading>
            <Text fontSize={{ base: '16px' }}>{copy.pathmatchProfileLive.body}</Text>
            <Link
                as={slug ? ReachLink : undefined}
                to={slug ? `/profile/${slug}`: '/createProfile'}
            >
                <Button
                    backgroundColor="#4747E6"
                    color="#FFFFFF"
                    mt="4"
                    mr="2"
                    px="6"
                    _hover={{
                        bg: 'brand.600'
                    }}
                >
                    <Text mr="1">{slug ? 'View your Profile' : 'Create Profile'}</Text>
                    <RightArrow fill="white" />
                </Button>
            </Link>
            {slug ? <CopyProfileButton slug={slug} /> : ''}
        </Box>
    );
}
